import { connect } from 'react-redux';
import React, { Component } from 'react';
import {resolve_refs, strip_props, spec_validator} from '../spec_utils';
import {TreeNavRoot,TreeNavMenu,TreeNavMenuItem,TreeNavNodes} from 'react-fe-bootstrap';
import RouteTree from './RouteTree';
import TagBadge from './TagBadge';
import {default_policy, prepare, submit} from '../request_client';
import SpecNode from './SpecNode';
import ResponsePopup from './ResponsePopup';
import _ from 'lodash';

const Authentication = props => {
  const {authentication} = props;
  return authentication ?
    <TagBadge className='glow' tag='Authenticated' style={{backgroundColor: '#ffcccc'}}/> :
    <TagBadge className='glow' tag='Unauthenticated' style={{backgroundColor: '#ccffcc'}}/>;
};

const MainApiUI = ({data}) => {
  const info = data.get('info').toJS();
  const spec = data.toJS();
  var validated = false;
  spec_validator.validate(spec).then(
    res => console.log(res),
    err => console.log(err)
  );
  if(validated){
    return null;
  }
  const policy = _.defaultsDeep({}, spec.routes.policy, default_policy);
  return <div className="api-info">
     <div className="api-info__head">
        <span className="api-info__head-title">{info.title} - v{info.version}</span>
        <span className="api-info__head-sub-title"> | &nbsp; {info.description}</span>
     </div>
     <div>
        <SpecNode path={[]} route={''} spec={spec} node={spec.routes} policy={policy}/>
     </div>
  </div>
};


class ApiContent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
       {
         this.props.specs.map(apis => <div className="main-api-div">
                <MainApiUI data={apis}/>
           </div>)
       }
       <ResponsePopup/>
      </div>
    );
  }
}

export default connect(
  state => (
    {
      specs: state.get('apis').get('specs'),
      selected: state.get('apis').get('selected')
    }
  ),
  dispatch => (
    {
      // do nothing
    }
  )
)(ApiContent);
